(function () {
  'use strict';

  function selectedValue(form, name) {
    var selected = form.querySelector('input[name="' + name + '"]:checked');
    return selected ? selected.value : '';
  }

  function initFaq(section) {
    section.querySelectorAll('[data-faq-task-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        var target = document.querySelector(link.getAttribute('href') + ' h2');
        if (!target) return;
        window.setTimeout(function () { target.focus({ preventScroll: true }); }, 0);
      });
    });

    var fitCheck = section.querySelector('[data-faq-fit-check]');
    if (!fitCheck) return;

    var submit = fitCheck.querySelector('[data-faq-fit-submit]');
    var result = fitCheck.querySelector('[data-faq-fit-result]');
    var sectionId = section.getAttribute('data-section-id');

    submit.addEventListener('click', function () {
      var need = selectedValue(fitCheck, 'need-' + sectionId);
      var floor = selectedValue(fitCheck, 'floor-' + sectionId);
      var size = selectedValue(fitCheck, 'size-' + sectionId);
      var depth = selectedValue(fitCheck, 'depth-' + sectionId);

      result.className = 'faq-fit__result';
      if (!need || !floor || !size || !depth) {
        result.textContent = 'Choose one answer in each group to see your summary.';
        result.dataset.state = 'incomplete';
        result.focus();
        return;
      }

      if (need === 'floor' && floor === 'flat' && size === 'within' && depth === 'within') {
        result.textContent = 'Your pool may be a good fit for a Poolease floor cleaner. Confirm the model-specific limits before ordering.';
        result.dataset.state = 'fit';
      } else if (need === 'other') {
        result.textContent = 'X1 and X1A are not designed to clean walls, steps, or the waterline. Contact Customer Support if you need help choosing another option.';
        result.dataset.state = 'not-fit';
      } else {
        result.textContent = 'Your pool may need a closer review. X1 and X1A are intended for compatible flat pool floors, water up to 8.2 ft. / 2.5 m deep, and slopes under 10 degrees. Contact Customer Support with your pool dimensions if you are unsure.';
        result.dataset.state = 'review';
      }
      result.focus();
    });
  }

  function init() {
    document.querySelectorAll('[data-section-type="faq"]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
